<template>
    <div class="boxlogo">
        <div class="brand">
            <img class="logo" :src="require('@/assets/images/img/logo_dt.png')" />
            <span class="brand-divider"></span>
            <div class="brand-text">
                <h1 class="brand-title">FreshMon Pulse</h1>
                <p class="brand-subtitle">ALWAYS FRESH · ALWAYS IN CONTROL</p>
            </div>
        </div>
        <div class="login_in_wrap">
            <section class="login_in">
                <div class="login-header">
                    <h2 class="loginTitle">{{ $t('text.UserLogin') }}</h2>
                    <div class="login-chips">
                        <span class="login-chip">{{ $t('text.UserLoginChip1') }}</span>
                        <span class="login-chip">{{ $t('text.UserLoginChip2') }}</span>
                        <span class="login-chip">{{ $t('text.UserLoginChip3') }}</span>
                        <span class="login-chip">{{ $t('text.UserLoginChip4') }}</span>
                    </div>
                </div>

                <!-- 登录方式 Tab：个人用户 / 企业用户 -->
                <div class="login-tabs" v-if="showTabs">
                    <div class="tab-slider" :class="{ 'is-enterprise': activeTab === 'enterprise' }"></div>
                    <div
                        class="tab-item"
                        :class="{ active: activeTab === 'personal' }"
                        @click="switchTab('personal')"
                    >{{ $t('accountRedesign.tab_personal') }}</div>
                    <div
                        class="tab-item"
                        :class="{ active: activeTab === 'enterprise' }"
                        @click="switchTab('enterprise')"
                    >{{ $t('accountRedesign.tab_enterprise') }}</div>
                </div>

                <el-form
                    autocomplete="on"
                    :model="form"
                    :rules="rules"
                    ref="form"
                    class="login_form"
                    label-position="left"
                    @submit.native.prevent
                >
                    <!-- 企业用户 - 普通模式：Company ID -->
                    <el-form-item v-if="showCompanyId" prop="companyCode">
                        <el-input
                            name="companyCode"
                            type="text"
                            v-model.trim="form.companyCode"
                            autocomplete="off"
                            :placeholder="$t('accountRedesign.placeholder_company_id')"
                            maxlength="30"
                        >
                            <i slot="prefix" class="el-icon-office-building"></i>
                        </el-input>
                    </el-form-item>

                    <el-form-item prop="username">
                        <el-input
                            name="username"
                            type="text"
                            v-model="form.username"
                            autocomplete="off"
                            :placeholder="$t('accountRedesign.placeholder_username_or_email')"
                        >
                            <i slot="prefix" class="el-icon-user"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input
                            name="password"
                            maxlength="30"
                            v-model="form.password"
                            :type="confirmNewSecretFlag == false ? 'password' : 'text'"
                            auto-complete="on"
                            :placeholder="$t('accountRedesign.placeholder_password')"
                            @keyup.native.enter="handleLogin"
                        >
                            <i slot="prefix" class="icon_prefix el-icon-lock" />
                            <i slot="suffix" :class="confirmNewSecretFlag == false ? 'iconfont icon-biyan' : 'el-icon-view'" @click="changeIconState('confirmNewSecretFlag')"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="validateCode">
                        <div class="flexbox">
                            <el-input
                                type="text"
                                :placeholder="validateCodePlaceholder"
                                @keyup.native.enter="handleLogin"
                                class="validateText"
                                v-model="form.validateCode"
                            >
                                <i slot="prefix" class="el-icon-key"></i>
                            </el-input>
                            <div @click="changeCode()" class="voliade">
                                <identify :identifyCode="identifyCode"></identify>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <div class="login-buttons">
                            <!-- 企业 Tab 普通模式：[Login] [以 Root 登录] -->
                            <el-button v-if="activeTab === 'enterprise' && !isRootLogin" class="btn-secondary" @click="toggleRootLogin">
                                {{ $t('accountRedesign.btn_switch_to_root') }}
                            </el-button>
                            <!-- 企业 Tab Root 模式：[以企业用户登录] [Login] -->
                            <el-button v-if="activeTab === 'enterprise' && isRootLogin" class="btn-secondary" @click="toggleRootLogin">
                                {{ $t('accountRedesign.btn_switch_to_enterprise') }}
                            </el-button>
                            <!-- 主登录按钮 -->
                            <el-button :loading="loading" :disabled="disabled" @click="handleLogin">
                                {{ $t('accountRedesign.btn_login') }}
                            </el-button>
                        </div>
                    </el-form-item>
                    <el-form-item class="registy-item">
                        <div class="lang-switch" @click="toggleLang" :title="currentLang === 'zh_CN' ? 'Switch to English' : '切换到中文'">
                            <span class="lang-option" :class="{ active: currentLang === 'zh_CN' }">中</span>
                            <span class="lang-option" :class="{ active: currentLang === 'en_US' }">EN</span>
                            <span class="lang-slider" :class="{ 'is-en': currentLang === 'en_US' }"></span>
                        </div>
                        <div class="links-group">
                            <span class="forget-link" @click="goForgetPassword">{{ $t('accountRedesign.link_forget_password') }}</span>
                            <span class="registy-link" @click="goRegister">{{ $t('accountRedesign.link_register') }}</span>
                        </div>
                    </el-form-item>
                </el-form>
            </section>
            <div class="groove-strip groove-strip-left"></div>
            <div class="groove-strip groove-strip-right"></div>
        </div>
        <div class="login-footer">
            <Footer></Footer>
        </div>
    </div>
</template>

<script>
import identify from './SIdentify'
import Footer from '../layout/Footer.vue'
import { STORAGE_PREFIX } from '@/config/storage'

export default {
  name: 'login',
  computed: {
    // 验证码输入框占位符
    validateCodePlaceholder () {
      const lang = this.$i18n && this.$i18n.locale
      return lang === 'en_US' ? 'Code' : this.$t('accountRedesign.placeholder_captcha')
    },
    // 当前语言
    currentLang () {
      return this.$i18n && this.$i18n.locale
    },
    // 是否显示 Company ID 输入框：企业 Tab + 非 Root 模式
    showCompanyId () {
      return this.activeTab === 'enterprise' && !this.isRootLogin
    },
    // 是否显示 Tab：始终显示
    showTabs () {
      return true
    },
    // 表单校验规则
    rules () {
      const identifyCodeFn = (rules, value, callback) => {
        if (this.identifyCode !== value) {
          callback(new Error(this.$t('accountRedesign.err_captcha_incorrect')))
        } else {
          callback()
        }
      }
      const baseRules = {
        username: [
          {
            required: true,
            message: this.$t('messageTitle.UsernameCannotBeEmpty').toString(),
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: this.$t('messageTitle.PasswordCannotBeEmpty').toString(),
            trigger: 'blur'
          }
        ],
        validateCode: [
          {
            required: true,
            message: this.$t('messageTitle.VerificationCodeCannotBeEmpty').toString(),
            trigger: 'blur'
          },
          {
            min: 4,
            max: 4,
            message: this.$t('messageTitle.CharacterLengthAt4').toString(),
            trigger: 'blur'
          },
          {
            validator: identifyCodeFn,
            trigger: 'blur'
          }
        ]
      }
      // 企业普通模式需要 Company ID
      if (this.showCompanyId) {
        baseRules.companyCode = [
          {
            required: true,
            message: this.$t('accountRedesign.placeholder_company_id'),
            trigger: 'blur'
          },
          {
            pattern: /^[0-9a-zA-Z_]{1,30}$/,
            message: this.$t('accountRedesign.label_company_id'),
            trigger: 'blur'
          }
        ]
      }
      return baseRules
    },
    i18n () {
      return this.$i18n.locale
    }
  },
  components: {
    identify,
    Footer
  },
  data () {
    return {
      // 当前登录 Tab：personal | enterprise
      activeTab: 'personal',
      // 是否为 Root 登录模式（仅 enterprise Tab 有效）
      isRootLogin: false,
      // 表单信息
      form: {
        username: '',
        password: '',
        validateCode: '',
        companyCode: ''
      },
      loading: false,
      disabled: false,
      pwdType: 'password',
      confirmNewSecretFlag: false,
      // 验证码初始值
      identifyCode: 'm6a8',
      // 验证码的随机取值范围
      identifyCodes: '123456789abcdefghjkmnpqrstuvwxyz'
    }
  },
  methods: {
    changeIconState () {
      this.confirmNewSecretFlag = !this.confirmNewSecretFlag
    },

    // 切换 Tab
    switchTab (tab) {
      this.activeTab = tab
      // 切换到个人 Tab 时重置 Root 状态
      if (tab === 'personal') {
        this.isRootLogin = false
      }
      // 清空 Company ID 防止脏数据
      if (tab === 'personal' || (tab === 'enterprise' && this.isRootLogin)) {
        this.form.companyCode = ''
      }
      // 切换 Tab 后清空表单校验状态
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate(['companyCode'])
      })
    },

    // 切换 Root 登录 / 普通企业登录
    toggleRootLogin () {
      this.isRootLogin = !this.isRootLogin
      // 切换到 Root 时清空 Company ID
      if (this.isRootLogin) {
        this.form.companyCode = ''
      }
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate(['companyCode'])
      })
    },

    // 跳转注册页（独立页面）
    goRegister () {
      this.$router.push('/register')
    },

    // 跳转忘记密码页
    goForgetPassword () {
      this.$router.push('/forget-password')
    },

    // 校验
    async justify () {
      try {
        return await this.$refs.form.validate()
      } catch (error) {
        return false
      }
    },

    async handleLogin () {
      const evt = window.event || {}
      const key = evt.keyCode || 0
      if (key === 13 && this.loading) return
      const flag = await this.justify()
      if (!flag) return
      this.loading = true
      this.disabled = true
      this.$loading.show({
        text: this.$t('buttonTitle.LoggingIn')
      })

      // 构造登录请求体
      // 个人 Tab：userType=personal
      // 企业 Tab 普通模式：userType=enterprise, loginMode=normal, companyCode 必填
      // 企业 Tab Root 模式：userType=enterprise, loginMode=root
      const payload = {
        username: this.form.username,
        password: this.form.password
      }
      if (this.activeTab === 'personal') {
        payload.userType = 'personal'
      } else {
        payload.userType = 'enterprise'
        payload.loginMode = this.isRootLogin ? 'root' : 'normal'
        if (!this.isRootLogin) {
          payload.companyCode = this.form.companyCode
        }
      }

      this.$store
        .dispatch('user/login', payload)
        .then((res) => {
          if (res.state.code === 200) {
            const { result } = res
            if (!result || !result.token) return
            // 登录成功提示根据登录方式区分
            const successKey = this.activeTab === 'personal'
              ? 'accountRedesign.success_login_personal'
              : (this.isRootLogin
                  ? 'accountRedesign.success_login_root'
                  : 'accountRedesign.success_login_enterprise')
            this.$message.success(this.$t(successKey))
            const { redirect } = this.$route.query
            // 防止 redirect 指向登录页自身导致死循环
            const safeRedirect = redirect && !redirect.startsWith('/login') ? redirect : '/home'
            localStorage.setItem('token', result.token)
            // 首次登录强制改密
            if (result.isFirstLogin === 1) {
              this.$router.push('/force-change-password')
            } else {
              this.$router.push(safeRedirect)
            }
          } else {
            // 登录失败：显示后端返回的错误消息（后端已做模糊化处理，不会泄露具体原因）
            this.$message.error(res.state.msg || this.$t('accountRedesign.login_failed'))
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
          this.disabled = false
          this.$loading.hide()
        })
    },

    // 点击验证码刷新验证码
    changeCode () {
      this.identifyCode = ''
      this.makeCode(this.identifyCodes, 4)
    },
    // 生成一个随机整数
    randomNum (min, max) {
      max = max + 1
      return Math.floor(Math.random() * (max - min) + min)
    },
    // 随机生成验证码字符串
    makeCode (data, len) {
      for (let i = 0; i < len; i++) {
        this.identifyCode += data[this.randomNum(0, data.length - 1)]
      }
    },
    // 中英文切换
    toggleLang () {
      const newLang = this.currentLang === 'zh_CN' ? 'en_US' : 'zh_CN'
      this.$i18n.locale = newLang
      this.$store.dispatch('app/setLanguage', newLang)
      localStorage.setItem(STORAGE_PREFIX + 'lang', newLang)
    }
  },
  mounted () {
    this.identifyCode = ''
    this.makeCode(this.identifyCodes, 4)
    // 从 URL 读取 mode=root 参数，自动切换到企业 Tab + Root 登录模式（企业初始账号）
    const mode = this.$route.query.mode
    if (mode === 'root') {
      this.activeTab = 'enterprise'
      this.isRootLogin = true
      this.form.companyCode = ''
    } else {
      // 从 URL 读取 companyCode 参数，自动切换到企业 Tab 并填充
      const companyCode = this.$route.query.companyCode
      if (companyCode) {
        this.activeTab = 'enterprise'
        this.isRootLogin = false
        this.form.companyCode = companyCode
        this.$nextTick(() => {
          if (this.$refs.form) this.$refs.form.clearValidate(['companyCode'])
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.boxlogo {
    position: relative;
    width: 100%;
    height: 100vh;
    min-height: 600px;
    overflow: hidden;
    background: url('~@/assets/bg/bg-1.jpg') no-repeat center center;
    background-size: cover;

    .brand {
        position: absolute;
        top: 30px;
        left: 60px;
        z-index: 10;
        display: flex;
        align-items: center;
        gap: 18px;

        .logo {
            height: 72px;
            display: block;
        }

        .brand-divider {
            width: 1px;
            height: 48px;
            background: linear-gradient(to bottom, transparent 0%, rgba(48, 78, 114, 0.45) 50%, transparent 100%);
            flex-shrink: 0;
        }

        .brand-text {
            display: flex;
            flex-direction: column;
            justify-content: center;
            line-height: 1.1;
        }

        .brand-title {
            margin: 0;
            font-family: 'Source Han Sans CN', 'PingFang SC', 'Microsoft YaHei', sans-serif;
            font-size: 26px;
            font-weight: 700;
            letter-spacing: 0.5px;
            color: #1f2937;
            /* 主题色渐变标题，跟随 --primary-color 切换 */
            background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-color-hover) 60%, var(--primary-color) 100%);
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        .brand-subtitle {
            margin: 6px 0 0 0;
            font-family: 'Helvetica Neue', 'Arial', sans-serif;
            font-size: 11px;
            font-weight: 500;
            letter-spacing: 2.5px;
            color: #6b7280;
            text-transform: uppercase;
        }
    }

    .login-footer {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 10;

        ::v-deep.el-footer {
            height: 60px !important;
            background: transparent;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        ::v-deep.el-footer span {
            color: rgba(56, 56, 56, 0.85);
        }
    }

    .login_in_wrap {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            z-index: 5;

            /* 凹槽内的独立白色细条 */
            .groove-strip {
                position: absolute;
                top: 45.44%;
                width: 0.84%;
                height: 8.94%;
                background: #ffffff;
                z-index: 6;
                pointer-events: none;
            }

            .groove-strip-left {
                left: 0.21%;
            }

            .groove-strip-right {
                right: 0.21%;
            }
        }

    .login_in {
            position: relative;
            width: 340px;
            background: #ffffff;
            filter: drop-shadow(0 8px 24px rgba(48, 78, 114, 0.18)) drop-shadow(0 2px 6px rgba(0, 0, 0, 0.04));
            /* 八边形：四角斜切 + 左右中间连续梯形凹槽 */
            clip-path: polygon(
                3.13% 0%, 96.87% 0%,
                100% 2.68%, 100% 44.36%,
                97.91% 45.26%, 97.91% 54.56%,
                100% 55.46%, 100% 97.32%,
                96.87% 100%, 3.13% 100%,
                0% 97.32%, 0% 55.46%,
                2.09% 54.56%, 2.09% 45.26%,
                0% 44.36%, 0% 2.68%
            );
            padding: 32px 32px 24px 32px;

            .login-header {
                text-align: center;
                margin: 0 0 24px 0;
            }

            .loginTitle {
                font-family: 'Source Han Sans CN';
                font-size: 28px;
                font-weight: 700;
                color: #1f2937;
                margin: 0 0 14px 0;
                letter-spacing: 0.5px;
                line-height: 1.2;
            }

            .login-chips {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                gap: 6px;
            }

            .login-chip {
                flex: 1;
                min-width: 0;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                padding: 4px 8px;
                font-size: 11px;
                font-weight: 500;
                color: #6b7280;
                background: #eef1f6;
                border-radius: 999px;
                line-height: 1.4;
                white-space: nowrap;
            }

            /* Tab 切换 */
            .login-tabs {
                position: relative;
                display: flex;
                background: #eef1f6;
                border-radius: 999px;
                padding: 3px;
                margin-bottom: 22px;

                .tab-item {
                    flex: 1;
                    text-align: center;
                    padding: 8px 0;
                    font-size: 13px;
                    font-weight: 500;
                    color: #9ca3af;
                    cursor: pointer;
                    border-radius: 999px;
                    position: relative;
                    z-index: 2;
                    transition: color 0.25s ease;
                    user-select: none;

                    &.active {
                        color: #fff;
                        font-weight: 600;
                    }
                }

                .tab-slider {
                    position: absolute;
                    top: 3px;
                    left: 3px;
                    width: calc(50% - 3px);
                    height: calc(100% - 6px);
                    border-radius: 999px;
                    background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-color-hover) 100%);
                    box-shadow: 0 2px 6px rgba(48, 78, 114, 0.35);
                    transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
                    z-index: 1;

                    &.is-enterprise {
                        transform: translateX(100%);
                    }
                }
            }

            /* Root 登录切换链接已移除，改为按钮形式 */

            .login_form {
                .el-form-item {
                    margin-bottom: 22px;
                }

                /* 登录按钮组：两个按钮并排 */
                .login-buttons {
                    display: flex;
                    gap: 10px;
                    width: 100%;

                    /* 主登录按钮：占据剩余空间 */
                    > .el-button:not(.btn-secondary) {
                        flex: 1;
                    }

                    /* 次要按钮（切换 Root / 企业用户）：固定宽度 */
                    .btn-secondary {
                        flex-shrink: 0;
                        min-width: 140px;
                        height: 48px;
                        border-radius: 8px;
                        background-color: #ffffff !important;
                        border: 1px solid var(--primary-color) !important;
                        color: var(--primary-color) !important;
                        font-size: 13px;
                        font-weight: 500;
                        letter-spacing: 1px;
                        transition: all 0.2s ease;

                        &:hover {
                            background-color: rgba(48, 78, 114, 0.06) !important;
                            box-shadow: 0 2px 8px rgba(48, 78, 114, 0.15);
                        }

                        &:active {
                            background-color: rgba(48, 78, 114, 0.1) !important;
                        }
                    }
                }

                .registy-item {
                    margin-top: 8px !important;
                    margin-bottom: 0 !important;

                    ::v-deep .el-form-item__content {
                        line-height: 1.8 !important;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    }
                }

                /* 忘记密码 + 注册链接容器：右对齐 */
                .links-group {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    margin-left: auto;
                }

                .registy-link,
                .forget-link {
                    color: #344962;
                    cursor: pointer;
                    font-size: 13px;
                    border-bottom: 1px solid #344962;
                    transition: all 0.2s ease;

                    &:hover {
                        color: var(--primary-color);
                        border-bottom-color: var(--primary-color);
                    }
                }

                /* 中英文切换 - 滑动式 toggle switch */
                .lang-switch {
                    position: relative;
                    display: inline-flex;
                    align-items: center;
                    width: 72px;
                    height: 28px;
                    padding: 2px;
                    border-radius: 999px;
                    background-color: #eef1f6;
                    cursor: pointer;
                    user-select: none;
                    overflow: hidden;
                    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.04);
                    outline: none;

                    &:focus,
                    &:active {
                        outline: none;
                    }

                    .lang-option {
                        position: relative;
                        z-index: 2;
                        flex: 1;
                        text-align: center;
                        font-size: 12px;
                        font-weight: 500;
                        line-height: 24px;
                        color: #9ca3af;
                        background-color: transparent;
                        transition: color 0.25s ease;

                        &.active {
                            color: #fff;
                            font-weight: 600;
                            background-color: transparent;
                        }
                    }

                    .lang-slider {
                        position: absolute;
                        top: 2px;
                        left: 2px;
                        z-index: 1;
                        width: calc(50% - 2px);
                        height: calc(100% - 4px);
                        border-radius: 999px;
                        background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-color-hover) 100%);
                        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
                        transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1), background 0.25s ease;

                        &.is-en {
                            transform: translateX(100%);
                        }
                    }

                    &:hover .lang-slider {
                        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
                    }
                }

                .el-input {
                    ::v-deep .el-input__inner {
                        height: 46px;
                        line-height: 46px;
                        border: 1px solid #e8ecf1;
                        border-radius: 8px;
                        background-color: #f5f7fa;
                        font-size: 14px;
                        color: #1f2937;
                        padding-left: 44px;
                        transition: all 0.2s ease;

                        &::placeholder {
                            color: #9ca3af;
                        }

                        &:focus {
                            border-color: var(--primary-color);
                            background-color: #ffffff;
                            box-shadow: 0 0 0 3px rgba(48, 78, 114, 0.12);
                        }

                        &:hover {
                            border-color: #9cb4d8;
                        }
                    }

                    ::v-deep .el-input__prefix {
                        left: 0;
                        width: 40px;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    ::v-deep .el-input__suffix {
                        height: 100%;
                        display: flex;
                        align-items: center;
                        padding-right: 8px;
                    }

                    ::v-deep .el-input__suffix-inner {
                        display: flex;
                        align-items: center;
                    }

                    ::v-deep .el-input__prefix-inner {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 100%;
                        height: 100%;
                    }

                    ::v-deep .el-icon-user,
                    ::v-deep .el-icon-lock,
                    ::v-deep .el-icon-key,
                    ::v-deep .el-icon-office-building,
                    ::v-deep .el-icon-view,
                    ::v-deep .iconfont {
                        font-size: 16px;
                        color: #6b7280;
                    }
                }

                .flexbox {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    width: 100%;

                    > .el-input {
                        flex: 1;
                        min-width: 0;
                    }

                    .voliade {
                        flex-shrink: 0;
                        width: 110px;
                        height: 46px;
                        cursor: pointer;
                        border-radius: 0;
                        overflow: hidden;
                        border: 1px solid #e8ecf1;
                        background-color: #f5f7fa;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        transition: all 0.2s ease;

                        &:hover {
                            border-color: var(--primary-color);
                            box-shadow: 0 0 0 3px rgba(48, 78, 114, 0.08);
                        }
                    }
                }

                ::v-deep .el-button {
                    height: 48px;
                    margin-top: 8px;
                    border-radius: 8px;
                    font-size: 15px;
                    font-weight: 500;
                    letter-spacing: 2px;
                    transition: all 0.2s ease;
                }

                /* 主登录按钮（非 btn-secondary）：占满剩余宽度，主题色填充 */
                ::v-deep .el-button:not(.btn-secondary) {
                    flex: 1;
                    background-color: var(--primary-color) !important;
                    border-color: var(--primary-color) !important;
                    color: #ffffff;

                    &:hover {
                        background-color: var(--primary-color-hover) !important;
                        border-color: var(--primary-color-hover) !important;
                        box-shadow: 0 4px 12px rgba(48, 78, 114, 0.3);
                    }

                    &:active {
                        background-color: var(--primary-color) !important;
                        border-color: var(--primary-color) !important;
                    }

                    &.is-loading {
                        background-color: var(--primary-color) !important;
                    }
                }
            }
        }
}

@media only screen and (max-width: 1024px) {
    .boxlogo {
        .login_in_wrap {
            left: 50%;
            transform: translate(-50%, -50%);
        }

        .brand {
            left: 20px;
            top: 18px;
            gap: 10px;

            .logo {
                height: 40px;
            }

            .brand-divider {
                height: 28px;
            }

            .brand-title {
                font-size: 16px;
            }

            .brand-subtitle {
                font-size: 9px;
                letter-spacing: 1.5px;
            }
        }
    }
}
</style>
